import { Heading as BaseHeading, Level } from "@tiptap/extension-heading";
import { mergeAttributes } from "../react";

export const Heading = BaseHeading.extend({
    addOptions() {
        return {
            ...(this.parent?.() ?? {}),
            levels: [1, 2, 3, 4, 5] as Level[],
        };
    },
    addAttributes() {
        return {
            ...(this.parent?.() ?? {}),
            collapsed: { default: false },
            seoLevelMigrated: { default: false },
        };
    },
    parseHTML() {
        return this.options.levels.map((level: number) => ({
            tag: `h${level}`,
            getAttrs: (element: HTMLElement) => {
                const seoLevelMigrated = element.getAttribute("seolevelmigrated") === "true";
                return { level: seoLevelMigrated ? level - 1 : level, seoLevelMigrated };
            },
        }));
    },

    renderHTML({ node, HTMLAttributes }) {
        const nodeLevel = parseInt(node.attrs.level, 10) as Level;
        const hasLevel = this.options.levels.includes(nodeLevel);
        const level = hasLevel ? nodeLevel : this.options.levels[0];

        return [
            `h${level + 1}`,
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { seoLevelMigrated: true }),
            0,
        ];
    },
});
